import validate from "/vercel/path0/node_modules/.pnpm/nuxt@4.4.2_@babel+core@7.29.0_@babel+plugin-syntax-jsx@7.28.6_@babel+core@7.29.0__@emnapi+cor_su35i2oa2kttk5fpcvuse4akkq/node_modules/nuxt/dist/pages/runtime/validate.js";
import _00_45maintenance_45global from "/vercel/path0/app/middleware/00-maintenance.global.ts";
import menu_45styling_45global from "/vercel/path0/app/middleware/menu-styling.global.ts";
import sitemap_45global from "/vercel/path0/app/middleware/sitemap.global.ts";
import trailing_45slash_45global from "/vercel/path0/app/middleware/trailing-slash.global.ts";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@4.4.2_@babel+core@7.29.0_@babel+plugin-syntax-jsx@7.28.6_@babel+core@7.29.0__@emnapi+cor_su35i2oa2kttk5fpcvuse4akkq/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  _00_45maintenance_45global,
  menu_45styling_45global,
  sitemap_45global,
  trailing_45slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}